var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-view',[_c('div',{attrs:{"id":"app"}},[_c('camera')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }